import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { TableContext } from '../../contexts/tableContext';

import styles from './profilepage.module.scss';

function ProfileLayout() {
  const { dashboardStyle } = useContext(TableContext);
  const { bodyStyle } = useContext(TableContext);

  return (
    <div className={styles[bodyStyle]}>
      <div className={styles[dashboardStyle]} id={styles.dashboardcont2}>
        <div className={styles.settingsection}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default ProfileLayout;
